export default "__VITE_ASSET__BOnm5YbJ__"